var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "small",
      attrs: {
        btnUnuse: _vm.btnUnuse,
        showMask: true,
        singleBtn: true,
        title: _vm.$t("walletMintage.mintageConfirm.title"),
        closeIcon: true,
        close: _vm.close,
        leftBtnTxt: _vm.$t("walletMintage.mintageConfirm.btn"),
        leftBtnClick: _vm.toMintage
      }
    },
    [
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.tokenName")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.tokenInfo.tokenName) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.tokenSymbol")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.tokenInfo.tokenSymbol) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.totalSupply")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.tokenInfo.totalSupply) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.decimals")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.tokenInfo.decimals) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.isReIssuable")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.tokenInfo.isReIssuable) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.mintageConfirm.balance")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.showBalance) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "_row" }, [
        _c("span", { staticClass: "_row_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.mintageConfirm.fee")) + " : ")
        ]),
        _vm._v(_vm._s(_vm.fee) + " dSLS\n        "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.btnUnuse,
                expression: "btnUnuse"
              }
            ],
            staticClass: "err"
          },
          [_vm._v(_vm._s(_vm.$t("hint.insufficientBalance")))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }